import StrategyType from 'enums/modules/strategies/strategyType';
import {
  StrategyDetail,
  StrategyListItem,
} from 'model/modules/strategies/strategies';
import sharesproApi from 'rtkQuery/sharespro/sharesproApiService';
import { SharesproApiResponse } from 'rtkQuery/sharespro/types/sharesproApiResponse';
import mapStrategyDetailFromApi from 'rtkQuery/sharespro/mapper/modules/strategies/mapStrategyDetailFromApi';
import mapStrategyListFromApi from 'rtkQuery/sharespro/mapper/modules/strategies/mapStrategyListFromApi';

export const strategiesApi = sharesproApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchStrategyList: builder.query<StrategyListItem[], void>({
      query: () => ({
        url: '/v3/finance/strategy/index',
        method: 'GET',
      }),
      transformResponse(
        baseQueryReturnValue: SharesproApiResponse<
          ApiListResponse<ApiFetchStrategyListItem>
        >
      ) {
        return mapStrategyListFromApi(baseQueryReturnValue.data.items);
      },
    }),
    fetchStrategyDetail: builder.query<StrategyDetail, StrategyType>({
      query: (id) => ({
        url: '/v3/finance/strategy/detail',
        method: 'GET',
        sendToken: true,
        params: { id },
      }),
      transformResponse(
        baseQueryReturnValue: SharesproApiResponse<ApiFetchStrategyDetailResponse>
      ) {
        return mapStrategyDetailFromApi(baseQueryReturnValue);
      },
    }),
  }),
});

export const { useFetchStrategyListQuery, useFetchStrategyDetailQuery } =
  strategiesApi;
